import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import {
  StyledHeader,
  StyledHeaderContainer,
  StyledMenuIcon,
  StyledButton,
} from 'helpers/StyledLoginComponentsHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import LanguageOptionsBackground from 'components/shared/LanguageOptionsBackground';
import { languageMapping } from 'helpers/constants';
import { connect } from 'react-redux';
import { updateLanguage } from 'react-localize-redux';

const StyledEmailLabelH4 = styled.h4`
  font-size: 18px;
`;

const MobileActionContainer = styled.div`
  padding: 24px;
`;

const StyledSelectedLanguage = styled.div`
  color: #26628d;
  font-size: 20px;
  font-weight: bold;
`;

const StyledLinkButton = styled.button`
  font-family: 'Circular';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: ${props => (props.img ? '#f4f4f4' : '#230cc2')};

  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0 0 5px 0;
  padding: 0;
  border-radius: 0px !important;

  &:hover {
    text-decoration: none;
    color: #a3c2ff !important;
  }

  &:focus {
    text-decoration: none;
  }
`;

const StyledButtonA = styled.a`
  color: #1b5b87;
  background-color: #c9deed;
  line-height: normal;
  height: 36px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-radius: 28px !important;
  padding: 12px 36px;
  text-align: center;
  cursor: pointer;
  font-family: 'Circular';
`;

const StyledLinkA = styled.a`
  font-family: 'Circular';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: ${props => (props.img ? '#f4f4f4' : '#4e4e4e')};

  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0 0 5px 0;
  padding: 0;
  border-radius: 0px !important;

  &:hover {
    text-decoration: none;
    color: #a3c2ff !important;
  }

  &:focus {
    text-decoration: none;
  }
`;

const ButtonContainerStyled = styled.span`
  display: inline-block;
  margin: 0 20px;
`;
const ButtonContainerBlockStyled = styled.span`
  display: block;
`;

export default props => {
  if (props.mobile) {
    return <MobileNavBar {...props} />;
  }
  return (
    <StyledHeader>
      <StyledHeaderContainer className="row">
        <ButtonContainerStyled>
          <LanguageOptionsBackground disabled={props.isAuthenticating} img={props.img} />
        </ButtonContainerStyled>
        <ButtonContainerStyled>
          {props.helpLink ? (
            <StyledButtonA href={!props.isAuthenticating && props.helpLink} target="_blank">
              {getTranslatedString('help')}
            </StyledButtonA>
          ) : (
            <StyledButton
              accentColor={AccentColor()}
              disabled={props.isAuthenticating}
              onClick={props.handleLoginHelpOpenClose}
            >
              {getTranslatedString('help')}
            </StyledButton>
          )}
        </ButtonContainerStyled>
      </StyledHeaderContainer>
    </StyledHeader>
  );
};

const MobileNavBar = props => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <StyledHeader mobile>
      {isOpen ? (
        <Fragment>
          <StyledHeaderContainer>
            <StyledMenuIcon onClick={() => setIsOpen(!isOpen)} />
          </StyledHeaderContainer>
          <MobileActionContainer>
            <StyledEmailLabelH4>Language</StyledEmailLabelH4>
            <MobileLanguageSelector handleLanguageChange={props.handleLanguageChange} />
            <StyledEmailLabelH4>Help</StyledEmailLabelH4>
            {props.helpLink ? (
              <StyledLinkA style={{ textAlign: 'left' }} href={props.helpLink} target="_blank">
                Trouble logging in?
                <br /> Learn more about the portal
              </StyledLinkA>
            ) : (
              <StyledLinkButton
                style={{ textAlign: 'left' }}
                onClick={props.handleLoginHelpOpenClose}
              >
                Trouble logging in?
                <br /> Learn more about the portal
              </StyledLinkButton>
            )}
          </MobileActionContainer>
        </Fragment>
      ) : (
        <StyledHeaderContainer>
          <StyledMenuIcon onClick={() => setIsOpen(!isOpen)} />
        </StyledHeaderContainer>
      )}
    </StyledHeader>
  );
};

class LanguageSelector extends Component {
  render() {
    const { defaultLanguages } = this.props;
    if (!defaultLanguages || defaultLanguages.length === 0 || defaultLanguages.length === 1)
      return null;

    const currentLanguage = getCurrentLocale();

    const languages = defaultLanguages.map(language => {
      if (language !== currentLanguage) {
        return (
          <ButtonContainerBlockStyled>
            <StyledLinkButton onClick={this.props.handleLanguageChange}>
              {languageMapping[language]}
            </StyledLinkButton>
          </ButtonContainerBlockStyled>
        );
      }

      return (
        <ButtonContainerBlockStyled>
          <StyledSelectedLanguage> {languageMapping[language]}</StyledSelectedLanguage>
        </ButtonContainerBlockStyled>
      );
    });

    return <Fragment>{languages}</Fragment>;
  }
}

let MobileLanguageSelector = connect(
  store => ({
    defaultLanguages: store.userTypes.defaultLanguages,
  }),
  { updateLanguage }
)(LanguageSelector);
